package br.com.vvrefeicoes.portal.domain.model

enum class UserRole {
    DIRECTOR,
    MANAGER,
    SUPERVISOR,
}
